export default ({ latitude: lat1, longitude: long1 }, { latitude: lat2, longitude: long2 }) => {
  const earthRadius = 6371000;

  const radLat1 = lat1 * (Math.PI / 180);
  const radLat2 = lat2 * (Math.PI / 180);

  const deltaRadLat = (lat2 - lat1) * (Math.PI / 180);
  const deltaRadLong = (long2 - long1) * (Math.PI / 180);

  const a =
    Math.sin(deltaRadLat / 2) ** 2 +
    Math.cos(radLat1) * Math.cos(radLat2) * Math.sin(deltaRadLong / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return earthRadius * c;
};
